exports.default = {
  'title': 'Select reference images',
  'selected_title': 'Selected images',
  'selected_count': '{current}/{max} selected',
  'source_tabs': 'Image sources',
  'open_picker': 'Select reference images',
  'image': 'Image',
  'recent': 'Recent',
  'assets': 'Assets',
  'all_assets': 'All assets',
  'default_space': 'Default space',
  'folder_filter': 'Filter by folder',
  'upload_action': 'Click or drop to upload',
  'upload_hint': 'PNG, JPG, JPEG, or WebP. Up to 20 MB each.',
  'uploading': 'Uploading {current}/{total}',
  'limit_reached': 'Limit reached',
  'image_alt': 'Reference image',
  'remove': 'Remove',
  'remove_image': 'Remove image {name}',
  'select_image': 'Select image {name}',
  'unselect_image': 'Unselect image {name}',
  'unnamed': 'Untitled image',
  'empty_recent': 'No recently uploaded images',
  'empty_assets': 'No image assets',
  'load_failed': 'Could not load images',
  'loading_more': 'Loading more...',
  'retry': 'Retry',
  'retry_folders': 'Reload folders',
  'retry_preview': 'Retry preview',
  'retry_image_preview': 'Reload image {name}',
  'loading_preview': 'Loading',
  'retry_load_more': 'Could not load more. Click to retry.',
  'unsupported_type': '{count} unsupported images were skipped',
  'file_too_large': '{count} images over 20 MB were skipped',
  'remaining_limit': 'You can select {count} more images',
  'max_count': 'Select up to {count} images',
  'upload_failed': '{count} images failed to upload. Try again.',
  'play_audio': 'Listen',
  'pause_audio': 'Pause',
  'retry_audio': 'Retry audio',
  'stop_audio': 'Stop listening',
  'audio_audition': 'Audio preview',
  'audio_failed': 'Audio could not play. Retry or use the playback controls.',
  'media_selected_title': 'Selected media',
  'media_selected_count': '{current}/{max} selected',
  'media_source_tabs': 'Media sources',
  'media_remove_image': 'Remove media {name}',
  'media_select_image': 'Select media {name}',
  'media_unselect_image': 'Unselect media {name}',
  'media_unnamed': 'Untitled media',
  'media_empty_recent': 'No recently uploaded media',
  'media_empty_assets': 'No media assets',
  'media_load_failed': 'Could not load media',
  'media_retry_image_preview': 'Reload media {name}',
  'media_unsupported_type': '{count} unsupported media files were skipped',
  'media_file_too_large': '{count} empty files or files over 50MiB were skipped',
  'media_remaining_limit': 'You can select {count} more items',
  'media_max_count': 'Select up to {count} media items',
  'media_upload_failed': '{count} media files failed to upload. Try again.',
  'cancel': 'Cancel',
  'confirm': 'Use selected'
}
